export default __webpack_public_path__ + "img/a5a96b6ea9e07849a5ec861edcd8f113.png";